import React from 'react';
import type { ResponsiveImageOutput } from 'contracts';
import BackgroundImage from 'components/background-image';
import Html from 'components/html';

import { testId } from './category-card.settings';
import styles from './category-card.module.scss';

interface CategoryCardElement {
  src: ResponsiveImageOutput;
  category: string;
  name: string;
  nameVariant?: 'light' | 'dark';
  active?: boolean;
}

const CategoryCard: React.FunctionComponent<CategoryCardElement> = (props) => {
  const { src, category, name, active, nameVariant = 'light' } = props;

  return (
    <Html.div className={[styles.categoryCard, active && styles.active]} testId={testId.component}>
      <BackgroundImage className={['w-100 h-100', styles.image]} src={src} />
      <Html.div className={styles.curtain} />
      <Html.div className={styles.meta}>
        <Html.div className={[styles.name, styles[nameVariant]]}>{name}</Html.div>
        <Html.div className={styles.category}>{category}</Html.div>
      </Html.div>
    </Html.div>
  );
};

export type { CategoryCardElement };
export default CategoryCard;
